import React, { useState, useEffect } from "react";
import "./JoinView.css";
import { useParams } from "react-router-dom";
import { getGameInfo, joinGame, redicrectAuth } from "../../api";

const JoinGameSection = ({ gameData, onJoin, setOpen }) => {
  const [insufficientFunds, setInsufficientFunds] = useState(false);
  const [error, setError] = useState("");

  const balance = localStorage.getItem("balance");

  const sendJoinRequest = () => {
    if (Number(balance) < Number(gameData.bet)) {
      setInsufficientFunds(true);
      return;
    }
    setInsufficientFunds(false);
    joinGame(gameData.id, onJoin, setError);
  };

  const onReject = () => {
    setOpen(false);
  };

  const deposit = () => {
    window.location.href = `/walletop`;
  };

  return (
    <div className="overlay">
      <div className="modal">
        <p className="modal-title">
          Join the game with <strong>{gameData.admin}</strong>?
        </p>
        <p className="modal-text">
          The bet is <strong>{parseFloat(gameData.bet).toFixed(2)}</strong> TON
        </p>
        {error && <p className="error-modal">{error}</p>}
        <div className="modal-button-container">
          {insufficientFunds ? (
            <div>
              <div className="error-title">Insufficient funds</div>
              <div className="create-container">
                <button className="create-button" onClick={deposit}>
                  Deposit
                </button>
              </div>
            </div>
          ) : (
            <button
              className="modal-button-primary"
              type="submit"
              onClick={sendJoinRequest}
            >
              Yes
            </button>
          )}

          <button className="modal-button-secondary" onClick={onReject}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};

const FoundedGameView = ({ gameData }) => {
  const [open, setOpen] = useState(false);
  const onClick = () => {
    setOpen(true);
  };

  const onJoin = () => {
    setOpen(false);
    window.location.href = `/game/${gameData.id}`;
  };

  return (
    <div className="founded-game">
      <div className="input-title">Opponent</div>
      <div className="gameinfoversus">
        <div className="founded-input-text">{gameData.admin}</div>
      </div>
      <div className="margin8" />
      <div className="input-title">Bet</div>
      <div className="gameinfo">
        <img src="/ton.png" alt="toncoin" className="icon2" />
        <div className="founded-input-text">
          {parseFloat(gameData.bet).toFixed(2)}
        </div>
      </div>

      <div className="create-container">
        <button className="create-button" onClick={onClick}>
          Join
        </button>
      </div>
      {open && (
        <JoinGameSection
          gameData={gameData}
          onJoin={onJoin}
          setOpen={setOpen}
        />
      )}
    </div>
  );
};

const JoinView = ({}) => {
  if (redicrectAuth()) {
    window.location.href = "/";
  }

  const { id } = useParams();
  const [gameId, setGameId] = useState(id || "");
  const [error, setError] = useState("");
  const [gameData, setGameData] = useState(null);
  const balance = localStorage.getItem("balance");

  const handleGameIdChange = (e) => {
    setGameId(e.target.value);
    setGameData(null);
    setError("");
  };

  const onDataReceived = async (data) => {
    setGameData(data);
    setError("");
  };

  const setErrorWrapper = async (err) => {
    if (err == "404") {
      setError("Could not find a game");
    }
    if (err == "400") {
      setError("Incorrect Game Id");
    }
  };

  const handleFind = async () => {
    if (gameId) {
      await getGameInfo(gameId, false, onDataReceived, setErrorWrapper);
    } else {
      setError("Enter a Game Id");
    }
  };

  useEffect(() => {
    if (gameId) {
      handleFind();
    }
  }, []);

  const back = () => {
    window.location.href = `/menu`;
  };

  return (
    <div>
      <div className="container2">
        <button className="backbutton" onClick={back}>
          <img className="imagebackbutton" src="/home.svg" alt="Home" />
        </button>
        <div className="balance-text2">{parseFloat(balance).toFixed(2)}</div>
      </div>
      <div className="input-title">Game Id</div>
      {<p className="error">{error}</p>}
      <div className="input-amount">
        <img className="icon2" src="/die.svg" alt="Icon" />
        <input
          className="input-amount-input"
          value={gameId}
          onChange={handleGameIdChange}
        />
      </div>
      {gameData == null && (
        <div className="create-container">
          <button className="create-button" onClick={handleFind}>
            Find game
          </button>
        </div>
      )}

      {gameData && <FoundedGameView gameData={gameData} />}
    </div>
  );
};

export default JoinView;
